module.exports = "/dist/assets/images/gridview.svg";